// extracted by mini-css-extract-plugin
module.exports = {"container":"SportsbookBetconstruct__container--2l6","loadingContainer":"SportsbookBetconstruct__loadingContainer--18Y"};